module.exports = __webpack_public_path__ + "img/betsize_btn.a7663983.png";